import React from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../../theme/variables';
import TransitionText from '../common/TransitionText';
import SecondaryCopy from './SecondaryCopy';
import SecondaryHeadline from './SecondaryHeadline';
import { ReactComponent as PlayIcon } from '../../assets/icons/ButtonPlay.svg';
import { ReactComponent as PauseIcon } from '../../assets/icons/ButtonPause.svg';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

const useStyles = createUseStyles(
    {
        wrap: {
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
        },

        frame: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            paddingBottom: 100,
            width: '100%',
        },

        videoWrap: {
            position: 'relative',
            marginBottom: 32,
            width: '100%',
            paddingBottom: '56.25%',
        },

        video: {
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: variables.borderRadius.xl,
        },

        playPauseButton: {
            position: 'absolute',
            bottom: 28,
            left: 28,
        },
    },
    { name: 'SecondaryVideo' }
);

export default function SecondaryVideo({ hotspot, state }) {
    const classes = useStyles();
    const videoRef = useRef();
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.addEventListener('play', () => setPaused(false));
            videoRef.current.addEventListener('pause', () => setPaused(true));
        }
    }, [videoRef.current]);

    const togglePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    };

    return (
        <div className={classes.wrap}>
            <div className={classes.frame}>
                <div className={classes.videoWrap}>
                    <video
                        src={hotspot.content.video}
                        className={classes.video}
                        autoPlay
                        loop
                        ref={videoRef}
                    />
                    <button
                        className={classes.playPauseButton}
                        onClick={togglePlay}
                    >
                        {paused ? <PlayIcon /> : <PauseIcon />}
                    </button>
                </div>
                <SecondaryHeadline
                    title={hotspot.content.title}
                ></SecondaryHeadline>
                <SecondaryCopy>{hotspot.content.copy}</SecondaryCopy>
            </div>
        </div>
    );
}
